import { ERROR_COLORS, INFO_COLORS, PRIMARY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import {
  AT_SIGNING,
  EXPORTED,
  NEW,
  ACCESSED,
  ACCESSED_LE,
  REFUSED,
  SIGNED,
  SIGNED_LE,
  SMS_SENT,
  SENT_DEALER,
  SIGNED_ALL,
  SIGNED_ASTER,
  SIGNED_CLIENT
} from './statuses'

export const colorStatusesByCode = code => {
  const colors = {
    [NEW]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [AT_SIGNING]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [SMS_SENT]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [ACCESSED]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [ACCESSED_LE]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [SIGNED_ASTER]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [SIGNED_CLIENT]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [SIGNED_ALL]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [SIGNED]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [SIGNED_LE]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [SENT_DEALER]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [EXPORTED]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [REFUSED]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[700],
      border: `1px solid ${ERROR_COLORS[200]}`
    }
  }

  return colors?.[code] || {}
}

export const getStatusText = text => {
  switch (text) {
    case NEW:
      return 'Новый'
    case AT_SIGNING:
      return 'На подписании'
    case SIGNED_ASTER:
      return 'В процессе'
    case SIGNED_CLIENT:
      return 'В процессе'
    case SIGNED_ALL:
      return 'Подписан'
    case SIGNED:
      return 'Подписан'
    case REFUSED:
      return 'Отказано'
    case ACCESSED:
      return 'Получен доступ'
    case ACCESSED_LE:
      return 'Получен доступ ЮЛ'
    case EXPORTED:
      return 'Выгружен'
    case SIGNED_LE:
      return 'Подписан ЮЛ'
    case SMS_SENT:
      return 'Отправлен СМС'
    case SENT_DEALER:
      return 'Отправлен дилеру'
    default:
      return '-'
  }
}
